import React from "react";
import ContentLoader from "react-content-loader";
import { HideMobile } from "../../../02-atoms/06-layout/02-visibility/02-hide-mobile";
import { HideDesktop } from "../../../02-atoms/06-layout/02-visibility/01-hide-desktop";

/**
 * Responsive placeholder skeleton for forms when page is loading.
 * Provides responsive layout for both mobile and desktop views.
 */
export const FormPlaceholder = () => {
  const renderDesktopLoader = () => (
    <ContentLoader
      height={130}
      width="100%"
      style={{ maxWidth: "400px", margin: "0 auto" }}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="0%" y="0" rx="3" ry="3" width="62%" height="10" />
      <rect x="5%" y="20" rx="3" ry="3" width="55%" height="10" />
      <rect x="5%" y="40" rx="3" ry="3" width="42%" height="10" />
      <rect x="0%" y="60" rx="3" ry="3" width="62%" height="10" />
      <rect x="5%" y="80" rx="3" ry="3" width="50%" height="10" />
      <rect x="5%" y="100" rx="3" ry="3" width="20%" height="10" />
    </ContentLoader>
  );

  const renderMobileLoader = () => (
    <ContentLoader
      height={100}
      width="100%"
      style={{ maxWidth: "300px", margin: "0 auto" }}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="0%" y="0" rx="3" ry="3" width="80%" height="10" />
      <rect x="5%" y="20" rx="3" ry="3" width="70%" height="10" />
      <rect x="5%" y="40" rx="3" ry="3" width="60%" height="10" />
      <rect x="0%" y="60" rx="3" ry="3" width="80%" height="10" />
      <rect x="5%" y="80" rx="3" ry="3" width="50%" height="10" />
    </ContentLoader>
  );

  return (
    <>
      <HideMobile>{renderDesktopLoader()}</HideMobile>
      <HideDesktop>{renderMobileLoader()}</HideDesktop>
    </>
  );
};

export default FormPlaceholder;
